import { render, staticRenderFns } from "./TermOfTohoku.vue?vue&type=template&id=492e5398&"
import script from "./TermOfTohoku.vue?vue&type=script&lang=js&"
export * from "./TermOfTohoku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports